import { useLocation, useParams } from 'react-router';

export const useGetGameId = () => {
  const { pathname } = useLocation();
  const { lang } = useParams();
  const isGamePage = pathname.includes('/game/');
  const getGameId = () => {
    if (!isGamePage) return null;
    if (lang) return Number(pathname.replace(`/game/${lang}/`, ''));
    return Number(pathname.replace('/game/', ''));
  };
  const gameId = getGameId();
  return { gameId, isGamePage };
};
